module.exports = __webpack_public_path__ + "img/logo.080c55a4.png";